import { defineStore, acceptHMRUpdate } from "pinia";
import { createTranslationHighlightField } from "../lib/createTranslationHighlightField";

export const useTranslationIncluded = defineStore(
  "translation-content-included-field",
  createTranslationHighlightField({
    fieldId: "included",
    isRequired: true,
    highlightKey: "included",
    customKey: "custom_included",
    premadeKey: "premade_included",
  })
);

// HMR
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTranslationIncluded, import.meta.hot));
}
